import { render, staticRenderFns } from "./QuestionChangeApproval.vue?vue&type=template&id=60af29d3"
import script from "./QuestionChangeApproval.vue?vue&type=script&lang=ts"
export * from "./QuestionChangeApproval.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports